import FJCoreConfig from './../core/FJCoreConfig';
import FJUtil from './FJUtil';
import { VIEW_TYPE } from '../core/FJRenderViewConfig';
import localforage from 'localforage';
import FJConstant from '../constants/FJConstant.js';
import $ from 'jquery';

let _baseTimeForId = Date.now();
let _pageSize = { ...FJCoreConfig.refSize };
let inputInstance;
let _auxiliary = null;
let _currentRenderViewType = VIEW_TYPE.EDIT;
let localCountryCode = '';
let historyCache = {};
let _isShowingModalCommon = false;
const _recoveringMedias = [];
const _svgFormatResourceList = []; // 后缀是svg的资源列表
const _translateKeyMap = {}; // 用于记录搜索翻译后的映射表
const f_transitionsEaseMap = new Map(); // 用于记录转场类型对应的缓动类型
const f_transitionsSFXMap = new Map(); // 用于记录转场类型对应的音效类型
const f_cutoutSet = new Set(); // 用于记录已经抠图的数据
let f_transitionSFXList = [];

let _cropCanvas = null; // 用于绘制裁剪画布

/**
 *
 * latest为最近使用的对应转场类型的颜色 {key: colors} key为对应的转场的类型
 * board为故事板的对应转场类型的颜色 {key: {transitionType: colors}} key 为故事版的id
 *
 *
 * @desc 遮盖转场颜色映射表
 * @type {{board: {}, latest: {}}}
 */
let _overlayTransitionColorMap = {
    latest: {}, // 最近使用的对应的转场类型的颜色
    board: {}, // 故事板的对应转场类型的颜色
};

const pageSizeData = [
    [FJConstant.RATIO_SQUARE, 1],
    [FJConstant.RATIO_LANDSCAPE, 16 / 9],
    [FJConstant.RATIO_VERTICAL, 9 / 16],
    [FJConstant.RATIO_CINEMATIC, 21 / 9],
    [FJConstant.RATIO_SOCIAL, 4 / 5],
    [FJConstant.RATIO_PORTRAIT, 3 / 4],
    [FJConstant.RATIO_ULTRA_WIDE, 2 / 1],
];
const ratioMap = new Map(pageSizeData);

// 一些数据的存放和创建，获取的方法。用于set/get/create方法
const FJArchiveUtil = {
    /**
     * @description 生成id
     * @param {boolean} hash
     * @param {number} length
     * @return {string}
     */
    createId(hash, length = 16) {
        _baseTimeForId++;
        if (hash) {
            return FJUtil.hashValue(_baseTimeForId, length);
        } else {
            return _baseTimeForId.toString();
        }
    },

    createSVGId: function (value) {
        return (id = FJUtil.hashValue(value));
    },

    createExportViewWithSize: function (size) {
        let view = document.createElement('div');
        $(view).css({
            position: 'absolute',
            zIndex: -1,
            width: size.width,
            height: size.height,
        });
        return view;
    },
    createInput: function (acceptType, onchange, multiple) {
        inputInstance = inputInstance || document.createElement('input');
        $(inputInstance).attr({
            accept: acceptType,
            type: 'file',
        });
        inputInstance.onchange = e => {
            onchange(e);
            inputInstance.value = '';
        };
        inputInstance.click();
    },
    createSvgElement: function (tag, attr) {
        if (!document.createElementNS) return;
        let $svg = $(document.createElementNS('http://www.w3.org/2000/svg', tag));
        for (let key in attr) {
            switch (key) {
                case 'xlink:href': //文本路径添加属性特有
                    $svg[0].setAttributeNS('http://www.w3.org/1999/xlink', key, attr[key]);
                    break;
                default:
                    $svg.attr(key, attr[key]);
            }
        }
        return $svg[0];
    },

    getPageSize() {
        return _pageSize;
    },
    setPageSize(size) {
        _pageSize.width = size?.width || _pageSize.width;
        _pageSize.height = size?.height || _pageSize.height;
    },

    localStorageFunc: function (key, value) {
        if (typeof value === 'undefined') {
            //get
            return window.localStorage.getItem(key);
        } else {
            //set
            window.localStorage.setItem(key, value);
        }
    },
    setAuxiliary: function (ele) {
        _auxiliary = ele;
    },
    getAuxiliary: function () {
        return _auxiliary;
    },

    setCropCanvas: function (ele) {
        _cropCanvas = ele;
    },
    getCropCanvas: function () {
        return _cropCanvas;
    },

    /**
     * @desc 设置当前渲染页面的类型
     * @param {string} value - EDIT | READ_ONLY ... FJRenderViewConfig.VIEW_TYPE
     */
    setCurrentRenderViewType: function (value) {
        _currentRenderViewType = value;
    },
    getCurrentRenderViewType: function () {
        return _currentRenderViewType;
    },
    /**
     * @desc 获取当前渲染页面的元素的大小
     */
    getCurrentPreviewBoardViewSize: function () {
        let id = 'preview-video-canvas';
        const previewDom = document.getElementById(id);
        if (previewDom) {
            return {
                width: previewDom.offsetWidth,
                height: previewDom.offsetHeight,
                offsetWidth: previewDom.offsetWidth,
                offsetHeight: previewDom.offsetHeight,
            };
        }
        return {
            width: 0,
            height: 0,
        };
    },
    /**
     * @desc 获取当前渲染页面的元素的缩放比例
     */
    getCurrentPreviewBoardViewScale: function () {
        let id = 'preview-video-canvas';
        const previewDom = document.getElementById(id);
        if (previewDom) {
            const transformString = previewDom.style.transform;
            // 直接提取括号内的数字
            const match = transformString.match(/scale\(([^)]+)\)/);
            if (match) {
                const value = parseFloat(match[1]);
                return isNaN(value) ? 1 : value;
            }
            return 1;
        }
        return 1;
    },
    getCurrentElementView: function () {
        let id = 'preview-video-canvas';
        return document.getElementById(id);
    },
    getSvgWithForeignObject: function (size) {
        let xmlns = 'http://www.w3.org/2000/svg';
        let svg = document.createElementNS(xmlns, 'svg');
        let foreignObject = document.createElementNS(xmlns, 'foreignObject');
        const width = size.width || 0;
        const height = size.height || 0;
        svg.setAttributeNS(null, 'width', width);
        svg.setAttributeNS(null, 'height', height);
        svg.setAttributeNS(null, 'will-change', 'transform');
        foreignObject.setAttributeNS(null, 'width', width);
        foreignObject.setAttributeNS(null, 'height', height);
        foreignObject.setAttributeNS(null, 'x', 0);
        foreignObject.setAttributeNS(null, 'y', 0);
        let defs = document.createElement('defs');
        let styles = document.createElement('style');
        defs.appendChild(styles);
        svg.appendChild(defs);
        svg.appendChild(foreignObject);
        return svg;
    },
    getLocalCountryCode: function () {
        return new Promise((resolve, reject) => {
            try {
                if (localCountryCode) {
                    resolve(localCountryCode);
                } else {
                    $.get('https://www.cloudflare.com/cdn-cgi/trace', function (data) {
                        localCountryCode = data.split('\n')[8].match(/=(.*)/)[1];
                        resolve(localCountryCode);
                    });
                }
            } catch (e) {
                // FJGAManager.sendEvent('getUserLocation', "getUserLocation_fail", 0);
                reject();
            }
        });
    },

    initCoverCache: async function (coverKeys) {
        let keys = await localforage.keys();
        for (let i = 0; i < coverKeys.length; i++) {
            let { boardKey, contentKey } = coverKeys[i];
            let boardKeyHash = FJUtil.hashValue(boardKey);
            let contentKeyHash = FJUtil.hashValue(contentKey);
            keys.forEach(key => {
                if (key.includes(boardKeyHash) && !key.includes(contentKeyHash)) {
                    FJArchiveUtil.deleteCoverFromCache(key);
                }
            });
        }
    },
    /**
     * @desc 得到封面缓存的id
     * @param name
     * @return {string}
     */
    getCoverID: function (name) {
        return window.fjuser.info.current_space_id + '_' + window.p_id + '_' + name;
    },
    getCoverKey: function ({ boardKey, contentKey }) {
        return 'cover_' + FJUtil.hashValue(boardKey) + '_' + FJUtil.hashValue(contentKey);
    },

    /**
     * 根据width，height返回比例类型
     * @param width
     * @param height
     */
    ratioTypeBySize: function ({ width, height }) {
        let ratio = width / height;
        for (let [key, val] of ratioMap) {
            if (Math.abs(ratio - val) < 0.05) {
                return key;
            }
        }
        return FJConstant.RATIO_LANDSCAPE;
    },
    /**
     * 获取比例Map
     * @returns {Map<string, float>}
     */
    getRatioMap: function () {
        return ratioMap;
    },
    /**
     * @description 返回模板比列（存在些许的误差）
     * @param radio
     * @returns {*}
     */
    getStandardRadioByRadio: function (radio) {
        for (let [key, val] of ratioMap) {
            if (Math.abs(radio - val) <= 0.01) {
                return val;
            }
        }
        return radio;
    },

    addSearchHistory: function (key, value, maxCount = 8) {
        if (value.trim() === '') {
            return;
        }
        value = value.toLowerCase();
        let history = FJArchiveUtil.localStorageFunc(key);
        history = history ? JSON.parse(history) : [];
        if (history.includes(value)) {
            let index = history.indexOf(value);
            history.splice(index, 1);
            history = [value, ...history];
        } else {
            history.unshift(value);
        }
        FJArchiveUtil.localStorageFunc(key, JSON.stringify(history.slice(0, maxCount)));
        FJArchiveUtil.dispatchHistory(key);
    },
    getSearchHistory: function (key) {
        let history = FJArchiveUtil.localStorageFunc(key);
        history = history ? JSON.parse(history) : [];
        return history;
    },
    clearSearchHistory: function (key) {
        FJArchiveUtil.localStorageFunc(key, []);
        FJArchiveUtil.dispatchHistory(key);
    },
    subscribeHistory: function (type, callback) {
        historyCache[type] = historyCache[type] || [];
        if (!(callback instanceof Function)) {
            return;
        }
        historyCache[type].push(callback);
        return () => {
            let caches = historyCache[type] || [];
            let idx = caches.indexOf(callback);
            if (idx !== -1) {
                historyCache[type] = caches.slice(0, idx).concat(caches.slice(idx + 1));
            }
        };
    },
    dispatchHistory: function (type) {
        let caches = historyCache[type] || [];
        caches.forEach(callback => callback());
    },

    /**
     * @desc 获取遮盖转场的颜色映射表
     * @return {{}}
     */
    getOverlayTransitionColorMap: function () {
        return _overlayTransitionColorMap;
    },

    /**
     * 是否正在显示 FJModalCommon
     * @returns {boolean}
     */
    isShowingModalCommon: function () {
        return _isShowingModalCommon;
    },
    /**
     * 设置是否正在显示 FJModalCommon
     * @param show
     */
    setShowingModalCommon: function (show) {
        _isShowingModalCommon = show;
    },

    // 获取默认基础文字
    getDefaultTextData: function (tag) {
        let textData;
        switch (tag) {
            case 'en':
                textData = ['Enter Text Here'];
                break;
            case 'cn':
                textData = ['在此输入文字'];
                break;
            case 'de':
                textData = ['Hier Text eingeben'];
                break;
            case 'es':
                textData = ['Introduce el texto aquí'];
                break;
            case 'fr':
                textData = ['Entrez le texte ici'];
                break;
            case 'jp':
                textData = ['テキストを入力してください'];
                break;
            case 'pt':
                textData = ['Introduza o texto aqui'];
                break;
            case 'tw':
                textData = ['在此輸入文字'];
                break;
            case 'ar':
                textData = ['أدخل النص هنا'];
                break;
            default:
                textData = ['Enter Text Here'];
        }
        return textData;
    },

    addRecoveringMedia: function (id) {
        if (_recoveringMedias.indexOf(id) === -1) {
            _recoveringMedias.push(id);
        }
    },
    isRecoveringMedia: function (id) {
        return _recoveringMedias.indexOf(id) !== -1;
    },
    addSvgFormatResourceWithName: function (name) {
        _svgFormatResourceList.push(name);
    },
    getWidgetPreviewFormatByName: function (name) {
        return _svgFormatResourceList.indexOf(name) !== -1 ? 'svg' : 'png';
    },

    setTranslateKeyData: function (key, value) {
        _translateKeyMap[key] = value;
    },
    getTranslateValue: function (key) {
        return _translateKeyMap[key];
    },

    hasEaseTypeByTransitionType: function (type) {
        return f_transitionsEaseMap.has(type);
    },

    getEaseTypeByTransitionType: function (type) {
        return f_transitionsEaseMap.get(type);
    },

    setEaseTypeByTransitionType: function (type, easeType) {
        f_transitionsEaseMap.set(type, easeType);
    },

    hasSFXByTransitionType: function (type) {
        return f_transitionsSFXMap.has(type);
    },

    getSFXByTransitionType: function (type) {
        return f_transitionsSFXMap.get(type);
    },

    setSFXByTransitionType: function (type, SFXId) {
        f_transitionsSFXMap.set(type, SFXId);
    },

    hasCutoutMediaById: function (id) {
        return f_cutoutSet.has(id);
    },

    setCutoutMediaById: function (id) {
        f_cutoutSet.add(id);
    },

    getTransitionSFXList: function () {
        return f_transitionSFXList;
    },

    setTransitionSFXList: function (list) {
        f_transitionSFXList = [...list];
    },

    /**
     * 获取元素的扩展比例
     * @param element
     * @param domSize
     * @returns {number | {horizontal: number, vertical: number}}
     */
    getExpandSizeRatio: function () {
        let expandSize = 1.5;
        return expandSize;
    },
};

export default FJArchiveUtil;
